import { render, staticRenderFns } from "./DCVehicleRegistrationView.vue?vue&type=template&id=200a006d&"
import script from "./DCVehicleRegistrationView.vue?vue&type=script&lang=js&"
export * from "./DCVehicleRegistrationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports